import { Injectable } from '@angular/core';
import { User } from '../user/user';
import { PaymentType } from '../../sharedcomponents/_common/constants/app.constants';
import { currentcartdetail, ShopingCart } from '../../models/dashboard/cart/mywallet.currentcart.Modal';
import { UserGioLocation } from '../../models/user/usergioLocation';
import { AppSettings } from '../../sharedcomponents/_common/constants/app.constants';
import { Bank, BankAccountType } from '../../models/sendmoney/bankAccount';
export class SendMoneySettings {
  public static curStatus: SendMoneySteps.PickupCenter;
}

export enum PickupType {
  officePickup = 1,
  bankDeposit = 2,
  homeDelivery = 3,
  atmDeposit = 32
}

export enum locationType {
  singleLocation = 1,
  multiLocation = 2,
  collectAnyBranch = 3
}

export enum SendMoneySteps {
  PickupType = 0,
  PickupCenter = 1,
  Beneficiary = 2,
  PaymentType = 3,
  Summary = 4
}

// Order Status enum
export class ICE_OrderStatus {
  static inProcess = 'InProcess';
  static transmitted = 'Transmitted';
  static paid = 'Paid';
  static confirmed = 'Confirmed';
  static PendingFunding = 'PendingFunding';
  // new status code
  static ItemStatusPending = 'PMT_PENDING';
  static ItemStatusCancellationPending = 'PMT_CNCL_PENDING';
  static ItemStatusCanceled = 'PMT_CNCLD';
  static ItemStatusCompleted = 'PMT_CMPLTD';
  static ItemStatusPaymentFailed = 'PMT_FAILED';
  static ItemStatusUnKnown = 'PMT_STATUS_UNKNOWN';
}

@Injectable()
export class SendMoneyDetail { 
  isData: boolean = false;
  transactionId: number = 0;
  roundingPlaces: number = AppSettings.fractionDigit;
  userDetails: User = new User();
  pickupTypeDetails: PickupTypeDetails = new PickupTypeDetails();
  pickupCenterDetails: PickupCenterDetails = new PickupCenterDetails();
  agentDetails: AgentDetails = new AgentDetails();
  // paymentTypeDetails: PaymentTypeDetails = new PaymentTypeDetails();
  beneficiaryDetails: BeneficiaryDetails = new BeneficiaryDetails();
  summaryDetails: SummaryDetails = new SummaryDetails();
  storeDetails: StoreDetails = new StoreDetails();
  cardDetails: CardDetails = new CardDetails();
  paymentDetails: PaymentDetails = new PaymentDetails();
  billingAddressDetails: BillingAddressDetails = new BillingAddressDetails();
  bankDetails: Bank = new Bank();
  bankAccountDetails: BankAccountDetails = new BankAccountDetails();
  bankAccountTypeDetail: BankAccountType = new BankAccountType();
  branchDetails: BranchDetails = new BranchDetails();
  branches: Array<BranchDetails> = new Array<BranchDetails>();
  currentCartDetail: currentcartdetail = new currentcartdetail();
  additionalInfo: AdditionalInfo = new AdditionalInfo();
  userGioLocation: UserGioLocation = new UserGioLocation();
  shopingCartList: Array<ShopingCart> = new Array<ShopingCart>();
  sendMoneyProgramDetail: SendMoneyProgramDetail = new SendMoneyProgramDetail();
  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}

export class AdditionalInfo {
  fundSource: string = '';
  reasonSendingMoney: string = '';
}
export class UserDetails {
  FirstName: string = '';
  MiddleName: string = '';
  LastName: string = '';
  AdditionalLastName: string = '';
  DOB: string = '';
  CustomerEmail: string = '';
  Address: string = '';
  CityCode: string = '';
  CountryCode: string = '';
  StateCode: string = '';
  ZipCode: string = '';
  MobileNumber: string = '';
  PreferCountryCode: string = '';
  CustomerOccupation: string = '';
  CustomerEmployer: string = '';
  UserProfileImage: string = '';
  IsBeingLinked: string = '';
  LoyaltyCardNumber: string = '';
  StatusCode: string = '';
  StatusMessage: string = '';
  UserID: string = '';
  LastOrderNumber: string = '';
}

export class PickupTypeDetails {
  pickupType: number = 1;
  countryPreference: string = '';
  countryName: string = '';
  currencies: string = '';
  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}

export class AgentDetails {
  CurrencyFrom: string = AppSettings.BaseCountryCurrency;
  CurrencyTo: string = '';
  CountrySupportedCurrencyCodesTo: string = '';
  CountryFrom: string = AppSettings.BaseCountry;
  CountryTo: string = '';
  StateFrom: string = '';
  StateTo: string = '';
  CityTo: string = '';
  SearchForPayer: string = '';
  DeliveryMethod: Number = 1;
  SortBy: Number = 0;
  FilterBy: Number = 0;
  PayingAgentId: number = 0;
  AccountType: string = '';
  RecordCount: Number = 10;
  Amount: Number = 0;
  LocationId: Number = 0;
  ProgramId: Number = 0;
  Index: Number = 0;
  ImageData: string = '';
  AgentName: string = '';
  EndUserLatitude: string = '';
  EndUserLongitude: string = '';
  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}

export class PickupCenterDetails {
  AccountType: string = '';
  Currency: string = '';
  LocationId: number;
  LocationType: LocationType = new LocationType();
  PayingAgentId: number;
  PayingAgentName: string = '';
  PayingAgentRating: string = '';
  RateCustomer: number = 0.0;
  imgData: string = '';
  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}

export class LocationType {
  LocationTypeId: number;
  LocationTypeName: string = '';
  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}

export class BranchDetails {
  CustomerFee: number = 0.0;
  LocationAddress1: string = '';
  LocationAddress2: string = '';
  LocationBranchNumber: string = '';
  LocationCity: string = '';
  LocationCountryCode: string = '';
  LocationDirections: string = '';
  LocationId: number = 0;
  LocationLatitude: string = '';
  LocationLongitude: string = '';
  LocationName: string = '';
  LocationNotes: string = '';
  LocationPostalCode: string = '';
  LocationStateCode: string = '';
  MaximumLocalAmount: number = 0;
  MaximumLocalAmountExcludeFee: boolean = false;
  MinimumDenomination: number = 0;
  PayingAgentId: number = 0;
  PayingAgentName: string = '';
  PickupRequirements: string = '';
  RateCustomer: number = 0;
  Restrictions: string = '';
  ScheduleThisWeek: any = '';
  ScheduleThisWeek2: any = '';
  Session: string = '';
  SpecialInstructions: string = '';
  StatusCode: string = '';
  StatusMessage: string = '';
  Validation: AdditionalRequired = new AdditionalRequired();
  SummaryValidation: AdditionalRequired = new AdditionalRequired();
  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
  TaxAmount: number = 0.0;
  TaxDetails: taxDetail[];
}

export class AdditionalRequired {
  BankAccountDetail: boolean = false;
  BankAccountNumberMaximumLength: boolean = false;
  BankAccountNumberMinimumLength: boolean = false;
  IsBankAccountTypeRequired: boolean = false;
  IsBankCityRequired: boolean = false;
  IsBankCodeRequired: boolean = false;
  IsBankNameRequired: boolean = false;
  IsBeneficiaryAddressRequired: boolean = false;
  IsBeneficiaryIdentificationRequired: boolean = false;
  isBeneficiaryLastName2Required: boolean = false;
  IsBeneficiaryPhoneRequired: boolean = false;
  IsBeneficiaryRelationRequired: boolean = false;
  IsBeneficiaryValidAddressRequired: boolean = false;
  IsBeneficiaryZipCodeRequired: boolean = false;
  IsCustomerEmployerRequired: boolean = false;
  IsCustomerOccupationRequired: boolean = false;
  IsFundSourceRequired: boolean = false;
  IsTransferReasonRequired: boolean = false;
  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}

// export class PaymentTypeDetails {
//   id: number;
//   paymentType: string = '';
//   constructor(values: Object = {}) {
//     Object.assign(this, values);
//   }
// }

export class SummaryDetails {
  id: number;
  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}

export class StoreDetails {
  storeId: string = '';
  storeName: string = '';
  storeaddress: any = new Addresses();
  storeScheduleThisWeekThisWeek: string = '';
  storeOpeningTime: string = '';
  storeClosingTime: string = '';
  storespecialInstructionSection: string = '';
  storenotesSection: string = '';
  storedirections: string = '';
  storedistance: string = '';
  storemail: string = '';
  storeLimitations: string = '';
  storePhoneNumber: string = '';
  storeRestrictions: string = '';
  storeimgurl: string = '';
  storeimageurl: string = '';
  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}

export class CardDetails {
  nameOnCard: string = '';
  cardType: string = '';
  cardNumber: string = '';
  expirationDate: string = '';
  cardNickname: string = '';
  cardimageurl: string = '';
  CVV: string = '';
  cardFundingID = '';
  cardlastfournum = '';
  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}

export class PaymentDetails {
  paymentType: number = PaymentType.None;
  minimumDenomination: number = 0;
  srcCurrCode: string = AppSettings.BaseCountryCurrency;
  destCurrCode: string = '';
  exchangeRate: string ='';
  srcAmountWM: string = '0.00';
  destAmountWM: string = '0.00';
  srcAmount: number = 0.0;
  destAmount: number = 0.0;
  processingFee: number = 0.0;
  maxAllowedLimit: number = 0.0;
  fundingId: number = 0;
  totalAmount: number = 0.0;
  TaxAmount: number = 0.0;
  TaxDetails: taxDetail[];
  // Comented By Bharat -To verify wather it's used or not
  //  shareCredit: number = 0.0;
  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}

export class taxDetail { 
  Amount: number;
  Description: string;
  Name: string;
}

export class BillingAddressDetails {
  address: string = '';
  city: string = '';
  state: string = '';
  zipCode: string = '';
  country: string = '';
  CVV: string = '';
  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}

export class BankAccountDetails {
  BankAccountNumber: string = '';
  BankAccountType: string = '';
  BankCity: string = '';
  BankId: string = '';
  BankName: string = '';
  routingNumber: number = 0;
  BankState: string = '';
  BankZipCode: string = '';
  BankCountry: string = '';
  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}

export class BeneficiaryDetails {
  BeneficiaryId: number = 0;
  IdentificationNumber: string = '';
  IdentificationType: string = '';
  AdditionalLastName: string = '';
  Addresses = new Addresses();
  FirstName: string = '';
  MiddleName: string = '';
  LastName: string = '';
  NickName: string = '';
  Phone: string = '';
  EmailAddress: string = '';
  Relationship: string = '';
  address: string = '';
  infoText: string = '';
  city: string = '';
  state: string = '';
  zipCode: string = '';
  country: string = '';
  Checksum: string = '';
  callType: string = '';
  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}

export class Addresses {
  Address1: string = '';
  Address: string = '';
  CityCode: string = '';
  CountryCode: string = '';
  StateCode: string = '';
  ZipCode: string = '';
  Latitude: string = '';
  Longitude: string = '';
  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}

export class SendMoneyProgramDetail {
  ProgramId: string = '0';
  FromPage: string = 'dashboard';
  srcAmount: number = 0;
}
export class OldOrderData {
  Amount: number = 0;
  PickupType: PickupType = 0;
  PaymentType: PaymentType = PaymentType.None;
 }



// WEBPACK FOOTER //
// ./src/app/models/sendmoney/sendmoney.ts